var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content",staticStyle:{"margin":"0px auto 40px auto"}},[(_vm.loading)?_c('iframe-block',{attrs:{"iframeId":'iframe',"src":_vm.url}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }